module.exports = __webpack_public_path__ + "img/topic_have.2bd3a393.png";